import { render, staticRenderFns } from "./reportMessage.vue?vue&type=template&id=b194db38&scoped=true"
import script from "./reportMessage.vue?vue&type=script&lang=js"
export * from "./reportMessage.vue?vue&type=script&lang=js"
import style0 from "./reportMessage.vue?vue&type=style&index=0&id=b194db38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b194db38",
  null
  
)

export default component.exports